// src/Images/IconButton.js
import React from 'react';

const styles = {
  Button: (disabled) => ({
    cursor: disabled ? 'default' : 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '28px',
    height: '28px',
    border: '0',
    boxSizing: 'border-box',
    borderRadius: '32px',
    color: disabled ? '#9a9a9a' : '#ffffff',
    backgroundColor: disabled ? '#2f2f2f' : 'var(--company-color)',
    outline: 'none',
    opacity: disabled ? 0.6 : 1,
  }),
  Icon: {
    color: 'currentColor',
    fill: 'currentColor',
    width: '14px',
    height: '14px',
    fontSize: '14px',
  },
};

/** Perusnuolen path (chevron-tyyli) — käytetään ja kierrätetään suunnan mukaan */
const ChevronRight = () => (
  <path d="M128 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256 73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C144.4 444.9 136.2 448 128 448z" />
);

/** Ikonikomponentit jokaiselle suunnalle. Up/Down kiertävät samaa pathia. */
const LeftIconComponent = () => (
  <svg style={styles.Icon} viewBox="0 0 320 512" aria-hidden="true">
    <g transform="rotate(180 160 256)">
      <ChevronRight />
    </g>
  </svg>
);

const RightIconComponent = () => (
  <svg style={styles.Icon} viewBox="0 0 320 512" aria-hidden="true">
    <ChevronRight />
  </svg>
);

const UpIconComponent = () => (
  <svg style={styles.Icon} viewBox="0 0 320 512" aria-hidden="true">
    <g transform="rotate(-90 160 256)">
      <ChevronRight />
    </g>
  </svg>
);

const DownIconComponent = () => (
  <svg style={styles.Icon} viewBox="0 0 320 512" aria-hidden="true">
    <g transform="rotate(90 160 256)">
      <ChevronRight />
    </g>
  </svg>
);

const getIconForDirection = (dir = 'right') => {
  switch (dir) {
    case 'left': return LeftIconComponent;
    case 'up': return UpIconComponent;
    case 'down': return DownIconComponent;
    case 'right':
    default: return RightIconComponent;
  }
};

const IconButton = ({
  direction = 'right',
  onClick,
  disabled = false,
  title = '',
  ariaLabel,
  style,
  className,
  ...rest
}) => {
  const IconComponent = getIconForDirection(direction);
  return (
    <button
      type="button"
      style={{ ...styles.Button(disabled), ...(style || {}) }}
      className={className}
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel || title || direction}
      {...rest}
    >
      <IconComponent />
    </button>
  );
};

export default IconButton;

